import { getHomepageUrl } from '.';

import { APIError, NetworkError } from '../api/apiRequest';
import {
  CROSS_PARTITION_LOGIN_NOTICE,
  isCrossPartitionLoginError,
} from '../api/authErrors';
import * as authStore from '../stores/authStore';
import { StudioModalName } from '../stores/navigationStore';
import * as navigationStore from '../stores/navigationStore';
import * as noticesStore from '../stores/noticesStore';

export default async function handleGenericErrors(
  error: APIError | NetworkError,
  config?: {
    redirectTo?: string;
    suppressNotices?: boolean;
  },
) {
  if (error instanceof APIError) {
    // Cross-partition logins arrive as a 403 but are not a missing session, so
    // they must not fall through to the login prompt and redirect below: this
    // host can never authenticate the account.
    if (isCrossPartitionLoginError(error)) {
      if (!config?.suppressNotices) {
        noticesStore.error(CROSS_PARTITION_LOGIN_NOTICE);
      }
    } else if (error.status === 401 || error.status === 403) {
      if (!config?.suppressNotices) {
        noticesStore.warning('Please sign up or login to continue!');
      }

      if (config?.redirectTo) {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        authStore.logout(); // make sure we dont have a cookie
        window.location.href = getHomepageUrl(
          `/login?redirectTo=${config.redirectTo}`,
        );
      }
    } else {
      if (!config?.suppressNotices) {
        if (
          error?.message?.toLowerCase?.().includes('service unavailable') ||
          error?.message?.toLowerCase?.().includes('gateway timeout') ||
          error?.message?.toLowerCase?.().includes('request timed out')
        ) {
          noticesStore.error(
            'Your request timed out. Please try again or modify your request.',
          );
        } else if (error.status === 503 || error.status === 504) {
          noticesStore.error(
            'The server encountered an error. Please try again or come back later.',
          );
        } else if (
          error?.message.includes('Insufficient spins available for')
        ) {
          navigationStore.setModal(StudioModalName.READY_FOR_MORE_SPINS);
        } else {
          noticesStore.error(error.message);
        }
      }
    }
  } else if (error instanceof NetworkError) {
    if (!config?.suppressNotices) {
      noticesStore.error('Something went wrong, please try again later!');
    }
  }

  console.log('ERROR:', error);
}
